import { render, staticRenderFns } from "./auctionList.vue?vue&type=template&id=54a7ca8d&scoped=true&"
import script from "./auctionList.vue?vue&type=script&lang=js&"
export * from "./auctionList.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./auctionList.vue?vue&type=style&index=0&id=54a7ca8d&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "54a7ca8d",
  "00c5880d"
  
)

export default component.exports